<template>
<v-card>
  <v-card-title class="overline py-0 grey lighten-4" >
    Choose a location to edit
  </v-card-title>

  <v-subheader class="overline" >Pick a space</v-subheader>
  <space-picker chips v-model="spaceId" :return-object="false" />

  <v-card-text v-if="spaceId" >
    <v-subheader class="overline pl-1" >Pick a location</v-subheader>
    <location-picker chips
      v-model="locationId"
      :space-id="spaceId"
      :multiple="false"
      :return-object="false" />
  </v-card-text>
  <pre v-text="location" class="caption pa-2 grey lighten-4" />
</v-card>
</template>

<script>
import SpacePicker from '@/components/pickers/SpacePicker.vue'
import LocationPicker from '@/components/pickers/LocationPicker.vue'
export default {
  name: 'EditLocationForm',
  components: {SpacePicker, LocationPicker},
  data () {
    return {
      spaceId: null,
      locationId: null
    }
  },
  watch: {
    locationId () {
      this.launchLocationForm(this.spaceId, this.locationId)
    }
  }
}
</script>
